module.exports = __webpack_public_path__ + "assets/de408e316d2a5f66490d788dde8a5e0d.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/denoms/denom-6.mp3
 ** module id = 227
 ** module chunks = 0
 **/